<template>
  <div>
    <PageLoader v-bind:storage="appLoading" />
    <v-layout pt-4 pt-sm-0 pt-md-4 wrap justify-left>
      <v-flex xs12 xl11 px-2>
        <v-layout pt-3 wrap justify-start>
          <v-flex xs12 sm12 lg12 xl12>
            <v-layout wrap justify-start>
              <v-flex xs1 sm1 lg1 text-left align-self-center>
                <v-img
                  src="./../../../assets/Images/agogo.png"
                  contain
                  height="30px"
                ></v-img>
              </v-flex>
              <v-flex xs8 sm2 lg1 text-left align-self-center>
                <span
                  style="
                    font-family: poppinssemibold;
                    font-size: 18px;
                    color: #1c1c1c;
                  "
                >
                  Stocks
                </span>
                <!-- <span class="hidden-sm-and-up ibmbold appColor"
                  >- {{ appCategory }}</span
                > -->
              </v-flex>
              <!-- <v-flex
                class="hidden-xs-only"
                xs3
                py-2
                py-sm-0
                sm2
                lg2
                text-left
                px-2
                align-self-center
              >
                <v-btn block dark color="#FC4B4B" depressed elevation="4">
                  <span
                    :style="
                      $vuetify.breakpoint.name == 'xs'
                        ? 'font-family: poppinssemibold; font-size: 14px'
                        : 'font-family: poppinssemibold; font-size: 18px'
                    "
                  >
                    {{ appCategory }}
                  </span>
                </v-btn>
              </v-flex> -->
              <v-spacer class="hidden-xs-only"></v-spacer>
              <v-flex xs10 sm3 lg3 py-2 align-self-center text-left>
                <v-text-field
                  hide-details
                  :color="appColor"
                  placeholder="Search"
                  height="30px"
                  outlined
                  dense
                  append-icon="mdi-magnify"
                  v-model="search"
                  @change="getResult"
                >
                </v-text-field>
              </v-flex>
              <v-flex
                xs4
                sm4
                md3
                lg3
                text-left
                align-self-center
                px-12
                px-sm-6
                px-lg-1
                class="hidden-xs-only"
              >
                <v-select
                  outlined
                  dense
                  rounded
                  :color="appColor"
                  placeholder="Sub Category"
                  v-model="subCategory"
                  :items="appSubCategories"
                  item-text="name"
                  item-value="_id"
                  item-color="#FF1313"
                  hide-details
                  class="text-left"
                  clearable
                >
                  <template v-slot:item="{ item }">
                    <v-avatar>
                      <v-img
                        height="20px"
                        contain
                        :src="mediaURL + item.icon"
                      ></v-img>
                      <!-- <img style="boject-fit:contain" :src="mediaURL + item.icon" :alt="item.name" /> -->
                    </v-avatar>
                    &nbsp;
                    <span class="poppinsregular text-left">
                      {{ item.name }}
                    </span>
                  </template>
                </v-select>
              </v-flex>
              <v-flex
                xs1
                lg3
                text-right
                align-self-center
                px-6
                px-sm-12
                class="hidden-sm-and-up"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon class="align-center" v-bind="attrs" v-on="on"
                      >mdi-filter-variant</v-icon
                    >
                  </template>
                  <v-list>
                    <v-list-item
                      v-for="item in appSubCategories"
                      :key="item._id + 'g'"
                    >
                      <v-list-item-title
                        class="text-left"
                        @click="getData(item._id)"
                        >{{ item.name }}</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <!-- <v-layout wrap justify-start>
          <v-flex xs12 xl11>
            <SubCategorySlider />
          </v-flex>
        </v-layout> -->
        <!-- <v-layout wrap justify-start v-if="productTotalCount > 0">
          <v-flex xs12 sm7 md5 lg5 xl4 text-left align-self-center>
            <v-layout wrap justify-start fill-height>
              <v-flex xs2 sm2 md2 lg2 xl2 pl-xl-4 text-left align-center>
                <span
                  style="
                    color: #8d8d8d;
                    font-family: opensansbold;
                    font-size: 14px;
                  "
                >
                  Status
                </span>
              </v-flex>
              <v-flex xs10 sm10 md10 lg10 xl10 text-left align-center>
                <v-radio-group v-model="listStatus" row>
                  <v-radio
                    value="Active"
                    class="mx-2"
                    :label="'Active (' + activeCount + ')'"
                    :ripple="false"
                    color="#5DC57C"
                  ></v-radio>
                  <v-radio
                    value="Inactive"
                    class="mx-2"
                    :label="'Inactive (' + inactiveCount + ')'"
                    :ripple="false"
                    color="#5DC57C"
                  ></v-radio>
                  <v-radio
                    value="All"
                    class="mx-2"
                    :label="'All (' + totalCount + ')'"
                    :ripple="false"
                    color="#5DC57C"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout> -->
        <v-layout wrap>
          <v-flex xs12 py-2>
            <v-tabs
              v-model="tabValue"
              centered
              background-color="#202020"
              center-active
              dark
              show-arrows
            >
              <v-tab
                @click="getData(type.val)"
                :active-class="tabValue == $route.query.stat ? 'act' : ''"
                v-for="(type, i) in productTypeList"
                :key="i"
              >
                <!-- <span class="ibmsemibold"> -->
                <span class="ibmsemibold"> {{ type.name }}</span>
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-flex xs12 py-2 align-self-center text-left>
            <span class="ibmmedium appColor"
              >{{ totalProducts }} Product(s)</span
            >
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start v-if="products.length > 0">
          <template v-for="item in products">
            <v-flex xs12 xl11 :key="item._id.name" pr-lg-6 pr-xl-0>
              <InventoryItem v-bind:storage="item" @stepper="winStepper" />
            </v-flex>
            <v-flex xs12 xl11 :key="item._id.icon" py-4>
              <v-divider></v-divider>
            </v-flex>
          </template>
        </v-layout>
        <!-- <v-layout wrap justify-center v-if="pages > 1">
          <v-flex xs12>
            <v-pagination
              v-model="currentPage"
              :length="pages"
              :total-visible="7"
              color="#FF0000"
            ></v-pagination>
          </v-flex>
        </v-layout> -->
        <v-layout
          wrap
          fill-height
          pt-3
          pt-sm-16
          justify-center
          v-if="products.length < 1"
        >
          <v-flex xs12>
            <span
              style="
                font-family: poppinsregular;
                font-size: 20px;
                color: #000000;
              "
            >
              Oops! No Products Found
            </span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
// import SubCategorySlider from "./subCategorySlider";
import InventoryItem from "./allinventoryItem";
export default {
  components: {
    // SubCategorySlider,
    InventoryItem,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      currentPage: this.$route.query.page ? Number(this.$route.query.page) : 1,
      pages: 1,
      count: 10,
      tabValue: 0,
      productTotalCount: 0,
      products: [],
      activeCount: 0,
      inactiveCount: 0,
      totalCount: 0,
      productData: {},
      listStatus: "All",
      searchKey: null,
      colorr: null,
      color: null,
      subCategory: "",
      productType: "",
      search: null,
      productTypeList: [
        {
          name: "All Products",
          val: "",
        },
        {
          name: "Out of Stock",
          val: "outofstock",
        },
        {
          name: "Limited Stock",
          val: "limitedstock",
        },
        {
          name: "Best Selling",
          val: "bestselling",
        },
      ],
      totalProducts: null,
    };
  },
  computed: {
    appSubCategories() {
      return this.$store.state.subCategoryList;
    },
    appCategory() {
      return this.$store.state.category;
    },
  },
  watch: {
    // tabValue() {
    //   console.log("tes", this.tabValue);
    // },
    // search() {
    //   this.getResult()
    // },
    // tabValue() {
    //   if(this.$route.query.stat == 0) {
    //     this.tabValue=0
    //     this.getData()
    //   }
    //   if(this.$route.query.stat == 1) {
    //     this.tabValue=1
    //     this.getData('outofstock')
    //   }
    //   if(this.$route.query.stat == 2) {
    //     this.tabValue=2
    //     this.getData('limitedstock')
    //   }
    //   if(this.$route.query.stat == 3) {
    //     this.tabValue=3
    //     this.getData('bestselling')
    //   }
    // },
    subCategory() {
      if (this.tabValue == 0) {
        this.getData();
      }
      if (this.tabValue == 1) {
        this.getData("outofstock");
      }
      if (this.tabValue == 2) {
        this.getData("limitedstock");
      }
      if (this.tabValue == 3) {
        this.getData("bestselling");
      }
      // this.getData();
    },
    listStatus() {
      this.getData();
    },
    currentPage() {
      this.$router.push({
        path: "/Seller/Inventory",
        query: {
          page: this.currentPage,
        },
      });
    },
  },
  beforeMount() {
    // if(this.$route.query.stat){
    //   this.tabValue=this.$route.query.stat
    //   }
    if (this.$route.query.stat == 0) {
      this.tabValue = 0;
      this.getData();
    }
    if (this.$route.query.stat == 1) {
      this.tabValue = 1;
      this.getData("outofstock");
    }
    if (this.$route.query.stat == 2) {
      this.tabValue = 2;
      this.getData("limitedstock");
    }
    if (this.$route.query.stat == 3) {
      this.tabValue = 3;
      this.getData("bestselling");
    } 
    else if(!this.$route.query.stat){
      this.getData();
      // console.log("000");
    }
  },
  methods: {
    winStepper(window_data) {
      if (window_data.getData) {
        this.getData();
      }
    },
    getResult() {
      this.appLoading = true;
      localStorage.setItem("search", this.search);
      axios({
        method: "POST",
        url: "/product/search",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          keyword: this.search,

          userid: localStorage.getItem("userid"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$store.commit("searchedFor", response.data);
            this.$router.push("/Seller/Search");
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    getData(status) {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/seller/my/product/grouped/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          productType: status,
          subcategoryId: this.subCategory,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            // this.pages = response.data.pages;
            // this.activeCount = response.data.activecount;
            // this.inactiveCount = response.data.inactivecount;
            // this.totalCount = response.data.totalcount;
            this.totalProducts = response.data.totalProducts;
            // this.productTotalCount = response.data.totalcount;

            this.products = this.products.map((x) => {
              x.products = x.products.map((z) => {
                if (z.isColor) {
                  z.colorDetails = z.colorDetails.map((y) => {
                    y.color = JSON.parse(y.color);
                    y.colorHex = y.color.toString(16);
                    y.colorHex = y.colorHex.substring(2);
                    y.colorHex = "#" + y.colorHex;
                    return y;
                  });
                }
                return z;
              });
              return x;
            });

            // this.colorr = this.products
            // console.log("hxcolo=",this.colorr);
          } else {
            this.products = [];
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
<style scoped>
.act {
  color: white;
}
</style>
